import type {
  ActivityFeedResponse,
  GetPresignedUrlForGetPayload,
  GetPresignedUrlForGetResponse,
  GetPresignedUrlForPostPayload,
  GetPresignedUrlForPostResponse,
  Note,
  PatientDetailsResponse,
} from "@/core/types";
import type { AptiRequestConfig } from "@/lib/types/api";
import { getGroupAuthType } from "@/redux/actions/auth";
import { GROUP_AUTH_HEADER_NAME } from "@/constants/axios";
import { httpAuth } from "@/utils/axios";

export const sharedRequestsTyped = {
  fetch_patient_details: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: string;
  }): Promise<PatientDetailsResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/patient_management/${patientId}/patient_details`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<PatientDetailsResponse>;
  },

  get_activity_feed: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: string;
  }): Promise<ActivityFeedResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/patient_management/${patientId}/activity`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<ActivityFeedResponse>;
  },

  get_notes_summary: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: string;
  }): Promise<Note[]> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/patient_management/${patientId}/get_notes_summary`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<Note[]>;
  },

  get_presigned_url: function ({
    data,
    version = "v4",
  }: {
    data: GetPresignedUrlForGetPayload;
    version?: string;
  }): Promise<GetPresignedUrlForGetResponse> {
    const config = {
      data,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params: { showLoader: false },
      url: `/${version}/provider/get_presigned_url`,
    } satisfies AptiRequestConfig<GetPresignedUrlForGetPayload>;

    return httpAuth(config) as unknown as Promise<GetPresignedUrlForGetResponse>;
  },

  post_presigned_url: function ({
    data,
    version = "v4",
  }: {
    data: GetPresignedUrlForPostPayload;
    version?: string;
  }): Promise<GetPresignedUrlForPostResponse> {
    const config = {
      data,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params: { showLoader: false },
      url: `/${version}/provider/get_presigned_url`,
    } satisfies AptiRequestConfig<GetPresignedUrlForPostPayload>;

    return httpAuth(config) as unknown as Promise<GetPresignedUrlForPostResponse>;
  },
};
